export class Permissions {
    permissionName?: string;
}
